import React, { useEffect } from 'react';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import config from '../../../temp/config';
import { connect, useDispatch } from 'react-redux';
import { resetAppState, setOverlay } from '../../../redux/slices/appStateSlice';
import { resetQuoteData } from '../../../redux/slices/quoteDataSlice';
import { resetQuoteResponse } from '../../../redux/slices/quoteResponseSlice';
import { resetAddressResults } from '../../../redux/slices/addressResultsSlice';
import { OverlayConstants } from '../../../Constants';
import { useInternalNavigate } from '../../../utils/navigate/useNavigate';

const SessionTimeout = ({ fields, show }) => {
  const dispatch = useDispatch();
  const navigate = useInternalNavigate();

  const raiseEvent = () => {
    if (typeof window !== 'undefined' && fields.eventName?.value) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: fields.eventName?.value,
      });
    }
  };

  useEffect(() => {
    if (!isNaN(parseInt(config.sessionTime))) {
      const sessionTimer = setTimeout(() => {
        dispatch(resetAppState());
        dispatch(resetQuoteData());
        dispatch(resetQuoteResponse());
        dispatch(resetAddressResults());
        dispatch(setOverlay({ type: OverlayConstants.SessionTimeout, interstitial: true }));
        raiseEvent();
      }, config.sessionTime * 60 * 1000);
      return () => {
        clearTimeout(sessionTimer);
      };
    }
  }, []);

  if (!show) {
    return null;
  }

  const headerClick = () => {
    navigate(fields.headerCta.value.href);
  };

  const primaryCtaClick = () => {
    navigate(fields.primaryCta.value.href);
  };

  const secondaryCtaClick = () => {
    navigate(fields.secondaryCta.value.href);
    dispatch(setOverlay({ type: OverlayConstants.RetrieveQuote, interstitial: false }));
  };

  return (
    <section className="vds-error-page" data-testid={fields.testid?.value}>
      <nav className="vds-error-page__nav" aria-label="Primary navigation">
        <div className="vds-error-page__logo-link" onClick={headerClick} data-testid="header">
          <Image className="vds-global-navigation__logo" field={fields.headerLogo} />
        </div>
      </nav>
      <div className="vds-error-page__inner">
        <div className="vds-error-page__content">
          <Text tag="h2" field={fields.heading} />
          <RichText field={fields.content} />
          <div className="vds-cta-block vds-error-page__cta-container">
            <a
              className="vds-button vds-cta-block__button vds-button--line vds-error-page__cta"
              onClick={primaryCtaClick}
              data-testid="primary-cta"
            >
              <Text field={fields.primaryText} />
            </a>
            <a
              className="vds-button vds-cta-block__button vds-button--line vds-error-page__cta"
              onClick={secondaryCtaClick}
              data-testid="secondary-cta"
            >
              <Text field={fields.secondaryText} />
            </a>
          </div>
          <Image className="vds-error-page__image" field={fields.image} />
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    show: state.appState?.overlay?.type === OverlayConstants.SessionTimeout,
  };
};
export default connect(mapStateToProps)(SessionTimeout);
